"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _api = require("../../api/api");
var _cryptoJs = _interopRequireDefault(require("crypto-js"));
var _util = require("../../assets/static/js/utils/util");
var _cookie = require("@/assets/static/js/utils/cookie.js");
var _bootstrap = require("bootstrap");
var _default = exports.default = {
  name: 'password-login',
  inject: ['reload'],
  data: function data() {
    return {
      rememberMe: false,
      // 记住密码状态
      tips: "拖动左边滑块完成上方拼图",
      visible: false,
      slider: {
        mx: 0,
        bx: 0
      },
      //滑块x轴数据
      puzzle: false,
      //拼图是否正确
      userForm: {
        validatePhone: '',
        validatePass: ''
      },
      rules: {
        validatePhone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        },
        // TODO 为测试人员注释手机号限制
        {
          pattern: /^1\d{10}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        validatePass: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      },
      submitDisabled: false //登录注册按钮的disable控制
    };
  },
  watch: {
    visible: function visible(e) {
      if (e === true) {
        this.canvasInit();
        this.puzzle = false;
      }
    }
  },
  methods: {
    // 忘记密码
    toForgetPassword: function toForgetPassword() {
      this.$emit('forgotPassword');
    },
    // 登录
    toLogin: function toLogin(formName) {
      var _this = this;
      this.$refs[formName].validate( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var that, param, paramStr, reqParam;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!valid) {
                  _context.next = 9;
                  break;
                }
                that = _this;
                param = {
                  userAccount: that.userForm.validatePhone,
                  verificationCode: '',
                  userPassword: _cryptoJs.default.enc.Base64.stringify(_cryptoJs.default.HmacSHA256(that.userForm.validatePass, 'xiamenjinye')),
                  regSource: 'PC',
                  regScene: _this.$root.loginscene,
                  regSceneId: _this.$root.loginsceneid
                };
                paramStr = {
                  fun: 'verificationcodelogin',
                  param: param,
                  version: 1
                };
                reqParam = {
                  jsonParamete: JSON.stringify(paramStr)
                };
                _this.submitDisabled = true;
                // let paramStr = JSON.stringify(param)
                _context.next = 8;
                return that.loginTo(reqParam);
              case 8:
                if (that.$root.isLogin) _this.reload();
              case 9:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // async loginTo(param) {
    // 	let that = this
    // 	const {data} = await apiGetLogin(param)
    // 	if (data.proCode == '200') {
    // 		// session替换成cookie
    // 		setCookie( 'user' ,JSON.stringify(data.proData), 24*60*60)
    // 		setCookie( 'token' ,data.proData.token, 24*60*60)
    // 		// window.sessionStorage.setItem('user', JSON.stringify(data.proData))
    // 		// this.resetSetItem('user', JSON.stringify(data.proData))
    // 		// window.sessionStorage.setItem('token',data.proData.token)
    // 		// setTimeLocal('token2', data.proData.token, 7 * 24 * 60 * 60000)
    // 		that.$root.dialogFormVisible = false
    // 		that.$root.token = data.proData.token
    // 		this.$refs.userForm.resetFields()
    // 		this.$emit('loginStatus', true)
    // 		that.$message({
    // 			message: '登录成功!',
    // 			type: 'success'
    // 		});
    // 		that.$root.isLogin = true
    // 	}
    // 	that.submitDisabled = false
    // },
    // methods 内部
    loginTo: function () {
      var _loginTo = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(param) {
        var that, _yield$apiGetLogin, data, cipherText;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              _context2.next = 3;
              return (0, _api.apiGetLogin)(param);
            case 3:
              _yield$apiGetLogin = _context2.sent;
              data = _yield$apiGetLogin.data;
              if (data.proCode == '200') {
                // --- 记住密码逻辑：加密并存储 ---
                if (this.rememberMe) {
                  // 1. 加密密码
                  cipherText = _cryptoJs.default.AES.encrypt(this.userForm.validatePass, 'xiamenjinye').toString(); // 2. 存储账号和加密后的密码
                  localStorage.setItem('localUserAccount', this.userForm.validatePhone);
                  localStorage.setItem('localPass', cipherText);
                } else {
                  // 如果没勾选，建议清除，防止他人使用该电脑登录
                  localStorage.removeItem('localUserAccount');
                  localStorage.removeItem('localPass');
                }

                // 原有的存储 cookie 逻辑
                (0, _cookie.setCookie)('user', JSON.stringify(data.proData), 24 * 60 * 60);
                (0, _cookie.setCookie)('token', data.proData.token, 24 * 60 * 60);
                that.$root.dialogFormVisible = false;
                that.$root.token = data.proData.token;
                this.$refs.userForm.resetFields();
                this.$emit('loginStatus', true);
                that.$message({
                  message: '登录成功!',
                  type: 'success'
                });
                that.$root.isLogin = true;
              }
              that.submitDisabled = false;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loginTo(_x2) {
        return _loginTo.apply(this, arguments);
      }
      return loginTo;
    }(),
    // 初始化登录信息
    initRememberedPass: function initRememberedPass() {
      var localAccount = localStorage.getItem('localUserAccount');
      var localPass = localStorage.getItem('localPass');
      if (localAccount && localPass) {
        try {
          // 1. 自动填充账号
          this.userForm.validatePhone = localAccount;

          // 2. 解密密码并回填
          var bytes = _cryptoJs.default.AES.decrypt(localPass, 'xiamenjinye');
          var originalPass = bytes.toString(_cryptoJs.default.enc.Utf8);
          if (originalPass) {
            this.userForm.validatePass = originalPass;
            this.rememberMe = true; // 确保勾选框也是选中状态
          }
        } catch (e) {
          console.error("解密失败或本地数据损坏", e);
          localStorage.removeItem('localPass'); // 出错时清除异常数据
        }
      }
    }
  },
  created: function created() {
    this.initRememberedPass();
  }
};